import { domains } from 'config/env'
export const USER_MANAGEMENT_PATH = `${domains.ADMIN_DOMAIN}/user-management`
export const SUPPORTING_LESSON_INSTRUCTORS_PATH = `${domains.LEARN_APP_DOMAIN}/admin/implementation-guide/support/supporting-lesson-instructors`
export const DWB_SUPPORTING_LESSON_INSTRUCTORS_PATH = `${domains.LEARN_APP_DOMAIN}/product/digital-well-being/program-supports/supporting-dwb-lesson-instructors`
export const CSV_DOWNLOAD_LABEL = 'Download Reports'
export const DOWNLOAD_LINK_TEXT = 'Detailed Reports'
